import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, logout } from '../services/api'
import { useTranslation } from 'react-i18next'

export default function Settings() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [current, setCurrent] = useState('')
  const [newPass, setNewPass] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const [deleteConfirm, setDeleteConfirm] = useState('')
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [deleteError, setDeleteError] = useState('')
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (newPass !== confirm) { setError(t('settings.errorMatch')); return }
    setLoading(true); setError('')
    try {
      await api.post('/auth/change-password', { currentPassword: current, newPassword: newPass })
      setSuccess(true); setCurrent(''); setNewPass(''); setConfirm('')
    } catch (err: any) {
      setError(err.response?.data?.error || 'Chyba')
    } finally { setLoading(false) }
  }

  const handleDeleteAccount = async () => {
    if (deleteConfirm !== user?.email) {
      setDeleteError(t('settings.deleteEmailMismatch'))
      return
    }
    if (!window.confirm(t('settings.deleteConfirmDialog'))) return
    setDeleteLoading(true); setDeleteError('')
    try {
      await api.delete('/auth/account')
      await logout()
      navigate('/')
    } catch (err: any) {
      setDeleteError(err.response?.data?.error || 'Chyba')
      setDeleteLoading(false)
    }
  }

  const inputStyle: React.CSSProperties = { padding: '14px 16px', borderRadius: 12, border: '1px solid #e0e0e0', fontSize: 15, outline: 'none', width: '100%', boxSizing: 'border-box' }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: 20 }}>
      <div style={{ maxWidth: 500, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 0' }}>
          <button style={{ background: 'none', border: 'none', color: '#2D7A3A', fontSize: 17, cursor: 'pointer', padding: 0 }} onClick={() => navigate('/dashboard')}>{t('settings.back')}</button>
        </div>

        <div style={{ backgroundColor: '#fff', borderRadius: 20, padding: 32, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <h1 style={{ fontSize: 22, fontWeight: 600, color: '#1a1a1a', margin: '0 0 24px' }}>{t('settings.changePass')}</h1>

          {success && <div style={{ backgroundColor: '#f0fdf4', color: '#2D7A3A', padding: '12px 16px', borderRadius: 10, fontSize: 14, marginBottom: 16 }}>✅ {t('settings.success')}</div>}
          {error && <div style={{ backgroundColor: '#fff0f0', color: '#e74c3c', padding: '12px 16px', borderRadius: 10, fontSize: 14, marginBottom: 16 }}>{error}</div>}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <input style={inputStyle} type="password" placeholder={t('settings.current')} value={current} onChange={e => setCurrent(e.target.value)} required />
            <input style={inputStyle} type="password" placeholder={t('settings.new')} value={newPass} onChange={e => setNewPass(e.target.value)} required minLength={6} />
            <input style={inputStyle} type="password" placeholder={t('settings.confirm')} value={confirm} onChange={e => setConfirm(e.target.value)} required />
            <button style={{ padding: 14, borderRadius: 12, border: 'none', backgroundColor: '#2D7A3A', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer', marginTop: 4 }} type="submit" disabled={loading}>
              {loading ? t('settings.loading') : t('settings.submit')}
            </button>
          </form>
        </div>
        <div style={{ backgroundColor: '#fff', borderRadius: 20, padding: 32, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', marginTop: 16, borderTop: '3px solid #fee' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#e74c3c', margin: '0 0 8px' }}>
            {t('settings.deleteAccount')}
          </h2>
          <p style={{ fontSize: 14, color: '#888', margin: '0 0 16px' }}>
            {t('settings.deleteWarning')}
          </p>
          {deleteError && <div style={{ backgroundColor: '#fff0f0', color: '#e74c3c', padding: '12px 16px', borderRadius: 10, fontSize: 14, marginBottom: 12 }}>{deleteError}</div>}
          <input
            style={{ ...inputStyle, marginBottom: 10 }}
            type="email"
            placeholder={t('settings.deleteConfirmPlaceholder', { email: user?.email || '' })}
            value={deleteConfirm}
            onChange={e => setDeleteConfirm(e.target.value)}
          />
          <button
            onClick={handleDeleteAccount}
            disabled={deleteLoading}
            style={{ width: '100%', padding: 14, borderRadius: 12, border: 'none', backgroundColor: '#e74c3c', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}
          >
            {deleteLoading ? t('settings.deleting') : t('settings.deletePermanent')}
          </button>
        </div>
      </div>
    </div>
  )
}
